import { Box } from "@mui/material";
import "./_style.scss";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import TkBackButton from "../../components/molecules/TkBackButton";
import { fakeTableList, schema } from "./parts";
import { useContext, useEffect, useRef, useState } from "react";
import { GlobalContext } from "../../context/globalContext";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import { BusinessContext } from "../../context/businessContext";
import { TkRouteContext } from "../../context/tkRouteContext";
import { useLocation, useNavigate } from "react-router-dom";
import { httpAPI_STA019, httpAPI_STA022 } from "./api/request";
import { IAPI_STA019_Response, IAPI_STA022_Request } from "../../type/apiType";
import _ from "lodash";
import TkDialog from "../../components/atoms/TkDialog";

/**
 * SCRC080105 職員一覧
 * @return SCRC080105 職員一覧
 */
const SCRC080105 = (): JSX.Element => {
  const location = useLocation();
  const locationState = location.state;
  const navigate = useNavigate();
  const [statecorpInfoList, setStatecorpInfoList] = useState<any>([]);
  const stateFakeTableList = useRef(_.cloneDeep(fakeTableList));
  const { state, setState } = useContext(GlobalContext);
  const { state: businessState } = useContext(BusinessContext);
  const { state: stateRouter, setState: setStateRouter } =
    useContext(TkRouteContext);
  const isUserTypeKiko =
    state.authInfo?.userType === authorityUserType.userTypeNumber.KIKO;
  const contractorNo = isUserTypeKiko
    ? businessState.common?.contractorNo ?? businessState.job_114?.contractorNo
    : state.authInfo?.contractorNo;
  const displayContractorName =
    businessState.common?.contractorName ?? locationState?.contractorName;
  const [res, setRes] = useState<IAPI_STA019_Response>({});
  const [open, setOpen] = useState(false);
  const [saveData, setSaveData] = useState<any>();

  let resArr = stateFakeTableList.current;

  // 初期化
  const handleInit = async () => {
    let contractorName = resArr.find(
      (item) => item.keyword === "contractorName"
    )!;
    contractorName.contractorNumber =
      contractorNo + ":" + displayContractorName;
    contractorName.showLine = isUserTypeKiko;

    try {
      // 職員情報参照API呼び出し
      const res = await httpAPI_STA019({
        staffNo: locationState?.staffNo,
        contractorNo: contractorNo,
      });

      if (res.resultCd === "I0000") {
        // 氏名フリガナ
        let staffNameKana = resArr.find(
          (item) => item.keyword === "staffNameKana"
        )!;
        staffNameKana.setDefaultValue = res.staffNameKana;

        // 氏名
        let staffNameKanji = resArr.find(
          (item) => item.keyword === "staffNameKanji"
        )!;
        staffNameKanji.setDefaultValue = res.staffNameKanji;

        //氏名変更年月日
        let nameChangeDate = resArr.find(
          (item) => item.keyword === "nameChangeDate"
        )!;
        nameChangeDate.setDefaultValue = res.nameChangeDate;

        // 生年月日
        let birthday = resArr.find((item) => item.keyword === "birthday")!;
        birthday.setDefaultValue = res.birthday;

        // 性別
        let sex = resArr.find((item) => item.keyword === "sex")!;
        sex.setDefaultValue = res.sex;

        // 加入資格
        let joinCapacity = resArr.find(
          (item) => item.keyword === "joinCapacity"
        )!;
        joinCapacity.setDefaultValue = res.joinCapacity;

        // 職種
        let jobList = resArr.find((item) => item.keyword === "jobList")!;
        jobList.setDefaultValue = res.jobCd;

        // 福祉医療機構以外からの退職金受け取りの有無
        let prefectureRetirementJoinFlg = resArr.find(
          (item) => item.keyword === "prefectureRetirementJoinFlg"
        )!;
        prefectureRetirementJoinFlg.setDefaultValue = res.premasPastFlg;

        setRes(res);
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }

      setStatecorpInfoList([...resArr]);
    } catch (error) {
      navigate("/error");
    }
  };

  // 初期表示
  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const makeHttpObj = (obj: any): IAPI_STA022_Request => {
    const reqObj: IAPI_STA022_Request = {
      contractorNo,
      facilityNo: locationState?.facilityNo,
      staffNo: res.staffNo,
      staffNameKana: obj.staffNameKana,
      staffNameKanji: obj.staffNameKanji,
      birthday: obj.birthday,
      sex: obj.sex,
      businessType: businessState.common?.businessType,
      joinCapacity: obj.joinCapacity,
      jobCd: obj.jobList,
      prefectureRetirementJoinFlg: obj.prefectureRetirementJoinFlg,
      year: res.year,
      nameChangeDate: obj.nameChangeDate,
      updateDateTime: res.updateDateTime,
    };
    return reqObj;
  };

  //更新ボタン
  const onCheckAndSubmit = async (data: any) => {
    setSaveData(data);
    setOpen(true);
  };

  const onSave = async () => {
    setOpen(false);
    try {
      // 職員情報更新API呼び出し
      const res = await httpAPI_STA022({
        ...makeHttpObj(saveData),
      });

      if (res.resultCd === "I0000") {
        // API呼び出しの結果、正常終了した場合 遷移元画面に戻る
        let routerList = stateRouter.routerList || [];
        if (routerList.length > 1) {
          setStateRouter({
            ...state,
            routerList: [...routerList.slice(0, routerList.length - 1)],
          });
          navigate(`${routerList[routerList.length - 2].href}`);
        } else {
          setStateRouter({
            ...state,
            routerList: [...[]],
          });
          navigate("/error");
        }
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  return (
    <Box className="SCRC080105" data-testid="SCRC080105PageForTest">
      <TkFakeTable
        list={statecorpInfoList}
        ruleSchema={schema}
        onCheckAndSubmit={onCheckAndSubmit}
        buttonGroup={<TkBackButton />}
        submitButtonGroup={[
          {
            submitButtonText: "更新",
          },
        ]}
      />

      <TkDialog
        title="確認（情報を登録します）"
        contextText="　入力した内容で登録を行いますが、問題ないでしょうか。"
        okText="はい"
        cancelText="いいえ"
        open={open}
        onCancel={() => setOpen(false)}
        onSave={() => onSave()}
      />
    </Box>
  );
};

export default SCRC080105;
